import React, { Component } from 'react';
import TableComponentEnum from './../../utils/TableComponentEnum';
import Select from './../../select/';
import PropTypes from 'prop-types';

class SearchHeader extends Component {
    static propTypes = {
        children: PropTypes.node,
    };

    constructor() {
        super();
        this.selectedSearchDropdownInterval = 30;
        this.staticTableHeaderTitle = "";
    }

    static componentType = TableComponentEnum.TABLESEARCHHEADER;
    state = {};

    componentDidMount () {
        if (this.props.type !== undefined) {
            this.props.type === "cannedReportInactiveAccounts" ? this.selectedSearchDropdownInterval = 180 : 30;

            this.setState({
                tableHeaderTitle: this.props.type === "cannedReport" || this.props.type === "adHocReport" ?
                    this.props.tableHeaderTitle :
                    this.props.tableHeaderTitle + " for " + this.selectedSearchDropdownInterval + " days"
            })
        } else {
            if (this.props.tableHeaderTitle != undefined) {
                this.setState({
                    tableHeaderTitle: this.props.tableHeaderTitle
                })
            }

        }
    }

    handleInputChange = (event) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    // handle search button click
    handleSearchAction = () => {
        this.props.searchButtonAction(this.selectedSearchDropdownInterval);
    }

    handleDownloadFileAction = () => {
        this.props.downloadFileAction();
    }

    // handle combo box click
    handleSelectDropdownChange = (event) => {
        this.selectedSearchDropdownInterval = event.target.value;

        this.props.searchButtonAction(event.target.value);
        this.setState({
            tableHeaderTitle: this.props.tableHeaderTitle + " for " + this.selectedSearchDropdownInterval + " days"
        })
    }

    render() {
        const {
            children,
        } = this.props;
        return <div className = "portlet-title p-l-r-10">
            <div className = "caption">
                <i className = { this.props.headerClassName }/>{ this.state.tableHeaderTitle }
            </div>
            <div className="actions">
                {children}
                {(this.props.type !== undefined && this.props.type !== "cannedReport" && this.props.type !== "adHocReport") ?
                <Select className={"packages-status-dropdown"}
                        controlFunc={this.handleSelectDropdownChange}
                        options = {this.props.selectDropdownValues}>
                </Select>
                    : ''
                }
                <input type="button" value="Search" className="button-right btn-info" onClick={this.handleSearchAction} />
                {this.props.downloadFileAction != undefined ?
                    <input type="button" value="Download" className="button-right btn-info" onClick={this.handleDownloadFileAction} /> : ''}
            </div>
        </div>
    }
} export default SearchHeader;